import React, { lazy, useEffect, Suspense, useState } from "react";
import Messagebadge from "../Messagebadge/Messagebadge";
import Icon from "../../assets/icons/Icon";
import Tooltip from "../Tooltip/TooltipPopup";
import injectSheet from "react-jss";
import classNames from "classnames";
import Popup from "../Popup/Popup";
import { connect } from "react-redux";
import { fetchNotiser } from "../../redux/actions/actions";
import AbsoluteLoaderContainer from "../Loaders/AbsoluteLoaderContainer";
const NotisItem = lazy(() => import("./NotisItem"));

const NotiserNavItem = ({
  toggleSubmenu,
  visible,
  classes,
  userState,
  fetchNotiser,
  notisState,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getMessages(true); //Retrieve messages each 10 seconds
    let getMessagesInterval = setInterval(() => {
      getMessages();
    }, 14000);
    return () => clearInterval(getMessagesInterval);
  }, [userState]);

  useEffect(() => {
    if (isOpen) {
      getMessages(true);
    }
  }, [isOpen]);

  const handleOpenClose = () => {
    setIsOpen(!isOpen);
    if (toggleSubmenu) toggleSubmenu();
  };

  const justClose = (e) => {
    if (e.target.id !== "notiser") {
      setIsOpen(false);
      if (toggleSubmenu) {
        toggleSubmenu();
      }
    }
  };

  const getMessages = async (createDynamicNotis = false) => {
    if (userState && userState.id) {
      fetchNotiser(createDynamicNotis);
    }
  };

  return (
    <>
      <button
        id="notiser"
        className={classNames(className, visible && classes.active)}
        onClick={handleOpenClose}
      >
        <div id="notiser" style={{ display: "flex", alignItems: "center" }}>
          <div>
            <div id="notiser" className={classes.iconStyle}>
              <svg
                id="notiser"
                width="18px"
                height="18px"
                fill="white"
                viewBox="0 0 18 18"
              >
                <path
                  id="notiser"
                  d="M8,19.5c1.1,0,2-0.9,2-2H6C6,18.6,6.9,19.5,8,19.5z M14,13.5v-5c0-3.1-1.6-5.6-4.5-6.3V1.5 C9.5,0.7,8.8,0,8,0S6.5,0.7,6.5,1.5v0.7C3.6,2.9,2,5.4,2,8.5v5l-2,2v1h16v-1L14,13.5z"
                />
              </svg>
              {notisState && notisState.length > 0 && (
                <Messagebadge id="notiser">
                  {notisState.filter((x) => !x.laskvitterad).length}
                </Messagebadge>
              )}
            </div>
            <div id="notiser" className={classes.buttontext}>
              Notiser
            </div>
          </div>
        </div>
      </button>
      <Popup
        position="bottom"
        width="430px"
        overflowY="auto"
        height="269px"
        id="style-1"
        contentStyle={classes.popupContent}
        arrowStyle={classes.popupArrow}
        className={classes.popup}
        isOpen={isOpen}
        handleClose={justClose}
        doNotHandleClickOutside={false}
      >
        <Suspense
          fallback={<AbsoluteLoaderContainer totalCenter title="Laddar..." />}
        >
          {notisState.length > 0 ? (
            <>
              <div className={classes.notisInfo}>
                Du har {notisState.filter((x) => !x.laskvitterad).length} olästa
                notiser av {notisState.length}
                <div className={classes.popupheader}>
                  <button onClick={handleOpenClose} title="Stäng">
                    <Icon type="clear" width="16px" />
                  </button>
                </div>
              </div>
              <div style={{ marginTop: "46px" }} />
              {notisState.map((mess, index) => (
                <NotisItem
                  fetchNotiser={fetchNotiser}
                  closeNotificationPopup={handleOpenClose}
                  key={index}
                  message={mess}
                />
              ))}
            </>
          ) : (
            <div className={classes.noNotifications}>
              Du har för tillfället inga notifikationer!
            </div>
          )}
        </Suspense>
      </Popup>
      <Tooltip parent="message" />
    </>
  );
};

const styles = {
  noNotifications: {
    fontWeight: "500",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  active: {
    color: "white!important",
    background: "#182d58!important",
  },
  notisInfo: {
    position: "fixed",
    borderBottom: "solid 1px #dbe0e8",
    fontWeight: "500",
    fontSize: "14px",
    textAlign: "left",
    padding: "16px 8px 14px 16px",
    display: "flex",
    width: "420px",
    height: "46px",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "4px",
    backgroundColor: "white",
  },
  popupContent: {
    bottom: "0",
    top: "70px",
    right: "0",
    overflow: "auto",
    borderRadius: "15px",
    height: "325px",
  },
  popupArrow: {
    top: "unset",
    bottom: "-19px",
    right: "27px",
  },
  popupheader: {
    display: "none",
  },
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "5px",
    marginTop: "3px",
  },
  "@media (max-width: 1023px)": {
    popup: {
      marginTop: "56px",
    },
    popupContent: {
      height: "unset",
    },
    iconStyle: { marginBottom: "0", marginTop: "0" },
    buttontext: { display: "none", fontSize: "11px" },
    notisInfo: {
      width: "calc(100% - 25px)",
      alignItems: "center",
      justifyContent: "space-between",
    },
    popupheader: {
      display: "block",
      textAlign: "right",
      "& button": {
        border: "0",
        background: "transparent",
        padding: "10px",
        color: "black",
      },
    },
  },
};

const mapStateToProps = (state) => {
  return {
    userState: state.user.user,
    notisState: state.ovrigt.notiser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNotiser: (createDynamicNotis) =>
      dispatch(fetchNotiser(createDynamicNotis)),
  };
};

NotiserNavItem.displayName = "NotiserNavItem";
const ConnectedNotiser = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotiserNavItem);

export default injectSheet(styles)(ConnectedNotiser);
